import Task from '../schema/Task';
import {
    Todo,
    TaskImportance,
    TaskStatus,
    LinkedEntity,
    LinkedEmail,
    EMAIL_ENTITY_TYPE,
} from 'owa-todo-types';
import { userDate } from 'owa-datetime';
import { convertRestIdToEwsId } from 'owa-identifiers';

export function toTodo(taskItem: Task): Todo {
    let todoItem = {
        ...taskItem,
        ReminderDateTime: taskItem.ReminderDateTime
            ? userDate(taskItem.ReminderDateTime.DateTime)
            : undefined,
        CompletedDateTime: taskItem.CompletedDateTime
            ? userDate(taskItem.CompletedDateTime.DateTime)
            : undefined,
        DueDateTime: taskItem.DueDateTime ? userDate(taskItem.DueDateTime.DateTime) : undefined,
        OrderDateTime: taskItem.OrderDateTime ? userDate(taskItem.OrderDateTime) : undefined,
        Status: taskItem.Status as TaskStatus,
        Importance: taskItem.Importance as TaskImportance,
        Note:
            taskItem.Body?.Content && taskItem.Body.ContentType == 'Text'
                ? taskItem.Body.Content
                : undefined,
        LinkedEmail: getLinkedEmailEntity(taskItem.LinkedEntities),
    } as Todo;

    return taskItem ? todoItem : null;
}

function getLinkedEmailEntity(linkedEntities: [LinkedEntity]): LinkedEmail {
    if (!linkedEntities) {
        return null;
    }

    const emailEntities = linkedEntities.filter(entity => entity.EntityType == EMAIL_ENTITY_TYPE);
    return emailEntities.length == 0 ? null : toLinkedEmail(emailEntities[0]);
}

function toLinkedEmail(linkedEntity: LinkedEntity): LinkedEmail {
    return {
        Id: convertRestIdToEwsId(linkedEntity.Id),
        EntitySubtype: linkedEntity.EntitySubtype,
        DisplayName: linkedEntity.DisplayName,
    };
}
